import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import { AnswerMarkdown } from "lib/core_components/ai/AnswerMarkdown";
import { BidReportQuestionGroup } from "lib/hooks/api/bid/answers/useGetBidReportAnswers";
import { LoadingContent } from "../common_report_components/LoadingContent";
import { toInlineSources } from "../common_report_components/utils";

type Props = {
  summaryGroup: BidReportQuestionGroup | undefined;
  isStreaming: boolean | undefined;
  noticeId: string | undefined;
};
export default function QualificationSummary({ summaryGroup, isStreaming, noticeId }: Props) {
  const summaryAnswer = summaryGroup?.questions[0]?.answer?.answer;

  if (!summaryAnswer && !isStreaming) {
    return null;
  }

  return (
    <Summary>
      <Flex gap={16} alignItems="center" justifyContent="space-between" width="100%">
        <Text h3>Summary</Text>
        {isStreaming && <LoadingContent />}
      </Flex>
      {summaryAnswer && (
        <AnswerMarkdown
          answer={summaryAnswer}
          sources={toInlineSources(summaryGroup?.questions[0]?.sources ?? [], noticeId)}
        />
      )}
    </Summary>
  );
}

const Summary = styled(Flex)(({ theme }) => ({
  flexDirection: "column",
  padding: 24,
  alignItems: "flex-start",
  borderRadius: 8,
  backgroundColor: `${theme.colors.sysTextDefault}0A`, // 4% opacity
}));
